import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Box, Typography, LinearProgress } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

FeatureProgressCard.propTypes = {
  featureId: PropTypes.string.isRequired,
  runCount: PropTypes.number.isRequired,
  creditsConsumed: PropTypes.number.isRequired,
  categoryTotal: PropTypes.number.isRequired,
};

export default function FeatureProgressCard({
  featureId,
  runCount,
  creditsConsumed,
  categoryTotal,
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  const sharePercent = categoryTotal > 0
    ? Math.min((creditsConsumed / categoryTotal) * 100, 100)
    : 0;

  const label = t(`credits.features.${featureId}`, { defaultValue: featureId });

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" noWrap title={label}>
          {label}
        </Typography>
        <Typography variant="h4" sx={{ mt: 0.5 }}>
          {creditsConsumed.toLocaleString()}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {runCount.toLocaleString()} {t('credits.runs').toLowerCase()}
        </Typography>
        <Box sx={{ mt: 1.5 }}>
          <LinearProgress
            variant="determinate"
            value={sharePercent}
            sx={{
              height: 6,
              borderRadius: 1,
              backgroundColor: alpha(theme.palette.grey[300], 0.4),
              '& .MuiLinearProgress-bar': {
                borderRadius: 1,
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
